<div
	class="datatable-container-v3 c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs bee-shadow"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
	>
		<div class="o-stack__cell">
			<h5 class="card-title">{{ sectiontitle }}</h5>
			<span class="datatable-icon" *ngIf="hasData && tableConfig.enableDownload">
				<a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV($event)" target="_blank">
					<i class="fa fa-download" aria-hidden="true"></i>
				</a>
			</span>
		</div>
	</div>
	<div class="analytics-portlet-content">
		<ngx-datatable
			class="material"
			[columns]="dataTableObj.columns"
			[rows]="dataTableObj.data"
			[scrollbarV]="true"
			[sortType]="'single'"
			[cssClasses]="cssClasses"
			[columnMode]="'force'"
			[headerHeight]="50"
			[footerHeight]="0"
			[rowHeight]="isR4 ? rowHeight : 55"
			[reorderable]="reorderable"
		>
			<ngx-datatable-column
				name="{{ column.name }}"
				prop="{{ column.columnKey }}"
				class="{{ column.cellClass }} data_table_cell"
				*ngFor="let column of dataTableObj.columns; let i = index"
				[sortable]="true"
			>
				<ngx-datatable-column
					name="{{ column.name }}"
					prop="{{ column.prop }}"
					[resizeable]="false"
					[sortable]="true"
					[cellClass]="column.cellClass"
					[headerClass]="column.headerClass"
					[comparator]="column.comparator"
				>
					<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
						<span
							(click)="column.prop == 'date' ? customSort(column.prop) : numberSort(column.prop)"
							class="header_template"
							*ngIf="!column.columnHasTooltip; else elseBlock"
						>
							{{ colHeader.name }}
						</span>
						<ng-template #elseBlock>
							<span class="header_template">
								<span
									(click)="numberSort(column.prop)"
									appTooltip
									title="Tooltip"
									[title]="column.columnTooltip"
									data-size="big"
									[options]="tooltipOptions"
								>
									{{ colHeader.name }}
								</span>
							</span>
						</ng-template>
					</ng-template>
				</ngx-datatable-column>
				<ng-template ngx-datatable-cell-template let-value="value" let-rowIndex="rowIndex" let-row="row">
					<div
						class="data_table_row"
						[title]="column.prop === 'place' || column.prop === 'location' ? row[column.prop] : ''"
						*ngIf="!column.columnDisplayImage"
					>
						<span [title]="row[column.prop]">{{ row[column.prop] }}</span>
						<div class="progressbar" *ngIf="column.hasProgressBar && row[column.prop] !== '--'">
							<div class="bar primary-color-bg" [ngStyle]="getPercentage(row, column.prop)"></div>
						</div>
					</div>
					<div
						class="network-div"
						*ngIf="column.columnDisplayImage"
						[ngClass]="{ browser_logo: row['browser_logo_path'] }"
					>
						<div
							*ngIf="row['favicon_url']"
							class="network-logo"
							[ngStyle]="{ 'background-image': 'url(' + row['favicon_url'] + ')' }"
						></div>
						<div *ngIf="row['place']" class="network-name" [title]="row.place">{{ row['place'] }}</div>
						<img
							*ngIf="row['browser_logo_path']"
							class="datatable partner-logo"
							[src]="row['browser_logo_path']"
							alt="browser_logo_path"
						/>
						<div *ngIf="row['browser_name']" class="network-name" [title]="row.browser_name">
							{{ row['browser_name'] }}
						</div>
					</div>
				</ng-template>
			</ngx-datatable-column>
		</ngx-datatable>
	</div>
</div>
